module.exports = __webpack_public_path__ + "img/desktop_1.b0f30dd1.png";